var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgresscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.36 4.36011C45.0876 4.36011 49.7689 5.29128 54.1366 7.10044C58.5043 8.90961 62.4729 11.5614 65.8158 14.9043C69.1587 18.2472 71.8105 22.2158 73.6197 26.5835C75.4288 30.9512 76.36 35.6325 76.36 40.3601C76.36 45.0877 75.4288 49.769 73.6196 54.1367C71.8105 58.5044 69.1587 62.473 65.8158 65.816C62.4729 69.1589 58.5043 71.8106 54.1366 73.6198C49.7689 75.4289 45.0876 76.3601 40.36 76.3601C35.6324 76.3601 30.9511 75.4289 26.5834 73.6198C22.2156 71.8106 18.247 69.1589 14.9041 65.8159C11.5612 62.473 8.90948 58.5044 7.10032 54.1367C5.29115 49.769 4.35998 45.0877 4.35999 40.3601C4.35999 35.6325 5.29116 30.9512 7.10033 26.5835C8.9095 22.2158 11.5612 18.2472 14.9042 14.9042C18.2471 11.5613 22.2157 8.9096 26.5834 7.10044C30.9511 5.29127 35.6324 4.3601 40.36 4.36011L40.36 4.36011Z",
    stroke: "#EAECF0",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.36 4.36011C47.9624 4.36011 55.3697 6.76689 61.5203 11.2355C67.6708 15.7041 72.2487 22.0051 74.598 29.2355C76.9473 36.4659 76.9473 44.2544 74.598 51.4847C72.2487 58.7151 67.6708 65.0161 61.5203 69.4847",
    stroke: "#20B486",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgresscircle);
export default __webpack_public_path__ + "static/media/Progress circle.7bdf8390e2ed15ad7debdf6becded094.svg";
export { ForwardRef as ReactComponent };